export default {
  content: {
    contactTitle: 'Visítanos',
    direction: 'Address',
    phone: 'Phone',
    mail: 'Email',
    form: {
      name: 'Tell us your name',
      frase: '<strong>Let\'s work on your project! </strong>',
      email: 'info@grupoapok.com',
      ubicacion: 'Venezuela',
      empresa: 'My Awesome Company LTD',
      message: 'Tell us more about it',
      submit: 'Send',
      cancel: 'Cancel'
    },
    opciones: ['A Website for my business', 'An App to change the world', 'A custom design', 'Just have a little talk'],
    formularioComent: {
      title: 'Talk a little more',
      pregunta0: 'How do we call you?',
      pregunta1: 'How do we contact you?',
      pregunta2: 'What\'s the name of your company?',
      pregunta3: 'Where are you from?',
      pregunta4: 'What you like to talk about?'
    },
    header: 'We know that you have many questions like:',
    headerDescription: 'Is it expensive to make an app?<br/> What do I need to create my website? <br/><strong class=\'aqua\'>Where do I begin?</strong><br/> Which technology is the best for my project?',
    bodyFrase: 'Don’t worry,',
    bodyFrase1: 'We will answer all your questions',
    fraseCafe: '<strong>¡We make a great coffee!</strong>',
    aboutFrase: '<strong>What would you like to talk about?</strong>',
    textHeader: 'CONTACT US',
    textFooter: 'We will answer all your questions and help you in each step of your project',
    urgente: 'How soon would like to have your Site?',
    tiempo: ['The sooner the better', 'We have tight schedule', 'No hurry'],
    agregar: 'Tell us more about ',
    web: {
      title: 'A website for my business!',
      pregunta4: 'What kind of website would you like?',
      hint: 'Kind of Web',
      tipo: ['Personal', 'Corporate', 'Ecommerce', 'Multimedia']
    },
    app: {
      title: 'An App to change the world',
      pregunta4: 'What kind of app would you like?',
      hint: 'Kind of App',
      tipo: ['Personal', 'Corporate', 'Ecommerce', 'Multimedia']
    },
    dise: {
      title: 'An astonishing design',
      pregunta4: 'What kind of design would you like?',
      hint: 'About Design',
      tipo: ['Image', 'Advertising', 'Interfaces for Apps or Web']
    },
    agradecimientos: {
      titulo: 'Thanks for writing to us.',
      text: 'For a more personalized attention we suggest to arrange an online meeting or you can even visit our offices.'
    },
    selector: 'Select a item...',
    botonAtras: 'Back',
    findUsIn: 'Find us in:',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/contact.js